import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, switchMap, tap } from 'rxjs';
import { WhoAmIService } from 'src/app/auth/services/whoami.service';
import { User } from 'src/app/core/models/users';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'any',
})
export class PingService {
  private http = inject(HttpClient);
  private whoami = inject(WhoAmIService);

  private MGMT_URL = `${environment.RH_BASE_URL}`;

  // if authentication is expired or wrong, the http interception
  // will invalidate the session
  public ping(userId: string | undefined): Observable<User> {
    if (userId) {
      return this.http.get<User>(`${this.MGMT_URL}/users/${userId}`);
    } else {
      // First get user email from /users/me, then fetch full user with consents using /users/<email>
      return this.http.get<any>(`${this.MGMT_URL}/users/me`).pipe(
        switchMap(response => {
          // Handle wrapped response format: {"data": {"me": null}} or {"data": {"me": {...}}}
          let user = response;
          if (response && response.data && response.data.me !== undefined) {
            user = response.data.me;
          }

          if (user && user._id) {
            // Fetch full user document with consents
            return this.http.get<User>(`${this.MGMT_URL}/users/${user._id}`);
          }
          // If user is null or doesn't have _id, user is not authenticated
          // Throw error to trigger catchError in auth guard
          throw new Error('User not authenticated');
        }),
        tap(user => {
          this.whoami.setUserAndRole(user);
        })
      );
    }
  }
}
